import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';

import { memoriasApi } from './api';

/** "dd/mm" de uma data civil ISO, sem fuso: é o dia da viagem. */
export function ddmm(iso: string): string {
  return `${iso.slice(8, 10)}/${iso.slice(5, 7)}`;
}

export function plural(n: number, um: string, varios: string): string {
  return `${n} ${n === 1 ? um : varios}`;
}

export function useConfigMedia() {
  return useQuery({
    queryKey: ['config'],
    queryFn: async () => {
      const res = await fetch('/api/v1/config', { credentials: 'same-origin' });
      if (!res.ok) return { maps: null, media: false };
      return (await res.json()) as { maps: unknown; media: boolean };
    },
    staleTime: Infinity,
  });
}

export function useResumoDasMemorias(tripId: string) {
  return useQuery({ queryKey: ['memorias', tripId, 'resumo'], queryFn: () => memoriasApi.resumo(tripId), staleTime: 30_000 });
}

export function useFotosDoDia(tripId: string, dayId: string | null) {
  return useQuery({
    queryKey: ['memorias', tripId, 'dia', dayId],
    queryFn: () => memoriasApi.listar(tripId, dayId ?? undefined),
    enabled: !!dayId,
    staleTime: 30_000,
  });
}

/** Foto que acabou de subir: o feed e o álbum releem. */
export function useAtualizarAoEnviar(tripId: string) {
  const cliente = useQueryClient();
  useEffect(() => {
    const ao = () => void cliente.invalidateQueries({ queryKey: ['memorias', tripId] });
    window.addEventListener('nv:foto-enviada', ao);
    return () => window.removeEventListener('nv:foto-enviada', ao);
  }, [cliente, tripId]);
}
